<template>
  <div class="cart-checkout-bar flex--center--center">
    <u-button
      class="cart-checkout-bar__checkout-button"
      :disabled="isCheckoutButtonDisabled"
      @click="onCheckout"
    >
      {{ $t('action.checkout') }}
    </u-button>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { UButton } from 'universkin-shared';

import { types } from '@/store/types';

export default {
  name: 'CartCheckoutBar',
  components: { UButton },
  props: {
    isCheckoutButtonDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapMutations({ closeCart: types.mutations.TOGGLE_OPEN_CART }),
    onCheckout() {
      const { doctorSlug, hashedDataId } = this.$route.params;

      this.closeCart();
      this.$router.push({ name: 'CheckoutPage', params: { doctorSlug, hashedDataId } });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/colors.scss';
@import '../../assets/scss/cart.scss';

.cart-checkout-bar {
  padding: 24px 0 30px;

  &__checkout-button {
    width: 100%;
  }
}
</style>
